import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property, state, queryAssignedElements, } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { elements } from './sdb-elements.js';
const SLIDE_OUT_BACK_LEFT = [
    { transform: 'translateX(0)' },
    { transform: 'translateX(-100vw)' },
];
const SLIDE_OUT_BACK_RIGHT = [
    { transform: 'translateX(0)' },
    { transform: 'translateX(100vw)' },
];
const FOWARD_ANIMATION_OPTS = {
    duration: 500,
    easing: 'ease-in-out',
    iterations: 1,
};
const REVERSE_ANIMATION_OPTS = {
    ...FOWARD_ANIMATION_OPTS,
    direction: 'reverse',
};
export const SLIDE_LEFT_OUT = [
    SLIDE_OUT_BACK_LEFT,
    FOWARD_ANIMATION_OPTS,
];
export const SLIDE_RIGHT_OUT = [
    SLIDE_OUT_BACK_RIGHT,
    FOWARD_ANIMATION_OPTS,
];
export const SLIDE_LEFT_IN = [
    SLIDE_OUT_BACK_LEFT,
    REVERSE_ANIMATION_OPTS,
];
export const SLIDE_RIGHT_IN = [
    SLIDE_OUT_BACK_RIGHT,
    REVERSE_ANIMATION_OPTS,
];
/**
 * Slider element, used to wrap slideritem elements (max 5)
 *
 * @slot - Unnamed slot (default slot)
 *
 */
let SDBContentSlider = class SDBContentSlider extends LitElement {
    constructor() {
        super(...arguments);
        this.containerHeight = 0;
        this.slideIndex = 0;
        this.navigateToNextSlide = () => {
            this.navigateWithAnimation(1, SLIDE_LEFT_OUT, SLIDE_RIGHT_IN);
        };
        this.navigateToPrevSlide = () => {
            this.navigateWithAnimation(-1, SLIDE_RIGHT_OUT, SLIDE_LEFT_IN);
        };
    }
    render() {
        const containerStyles = {
            height: `${this.containerHeight}px`,
        };
        const buttonStyles = {
            height: `${this.containerHeight}px`,
            lineHeight: `${this.containerHeight}px`,
        };
        return html `
            <sdb-content-iconbutton
                style="${styleMap(buttonStyles)}"
                icon="fal fa-chevron-left"
                @click=${this.navigateToPrevSlide}
            >
            </sdb-content-iconbutton>
            <div id="container" style="${styleMap(containerStyles)}">
                <slot></slot>
            </div>
            <sdb-content-iconbutton
                style="${styleMap(buttonStyles)}"
                icon="fal fa-chevron-right"
                @click=${this.navigateToNextSlide}
            >
            </sdb-content-iconbutton>
        `;
    }
    async navigateWithAnimation(nextSlideOffset, leavingAnimation, enteringAnimation) {
        const elLeaving = this.slideElements[this.slideIndex];
        const leavingAnim = elLeaving.animate(leavingAnimation[0], leavingAnimation[1]);
        this.changeSlide(nextSlideOffset);
        const newSlideEl = this.slideElements[this.slideIndex];
        this.showSlide(newSlideEl);
        const enteringAnim = newSlideEl.animate(enteringAnimation[0], enteringAnimation[1]);
        await Promise.all([leavingAnim.finished, enteringAnim.finished]);
        this.hideSlide(elLeaving);
    }
    firstUpdated() {
        setTimeout(() => {
            this.containerHeight = this.getMaxElHeight(this.slideElements);
        });
        this.initializeSlide();
    }
    initializeSlide() {
        for (let i = 0; i < this.slideElements.length; i++) {
            if (i === this.slideIndex) {
                this.showSlide(this.slideElements[i]);
            }
            else {
                this.hideSlide(this.slideElements[i]);
            }
        }
    }
    changeSlide(offset) {
        const slideCount = this.slideElements.length;
        this.slideIndex =
            (slideCount + ((this.slideIndex + offset) % slideCount)) %
                slideCount;
    }
    showSlide(el) {
        el.classList.remove('slide-hidden');
    }
    hideSlide(el) {
        el.classList.add('slide-hidden');
    }
    getMaxElHeight(els) {
        return Math.max(0, ...els.map(el => el.getBoundingClientRect().height));
    }
};
SDBContentSlider.styles = [
    elements,
    css `
            ::slotted(*) {
                position: absolute;
            }

            ::slotted(.slide-hidden) {
                display: none;
            }

            :host {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            #container {
                display: flex;
                align-items: center;
                justify-content: center;
                flex: 1;
                margin: 0 18px;
                overflow: hidden;
                position: relative;
            }
        `,
];
__decorate([
    state()
], SDBContentSlider.prototype, "containerHeight", void 0);
__decorate([
    property({ type: Number })
], SDBContentSlider.prototype, "slideIndex", void 0);
__decorate([
    queryAssignedElements()
], SDBContentSlider.prototype, "slideElements", void 0);
SDBContentSlider = __decorate([
    customElement('sdb-content-slider')
], SDBContentSlider);
export { SDBContentSlider };
//# sourceMappingURL=sdb-content-slider.js.map